import type { KpiFormMetricFormValue } from '@salescore/client-redux'
import type { ViewConfigKpi } from '@salescore/core'

import type { KpiForm } from './atoms'

// kpiFormAtom (metricFormValue 形) を mutation 送信用 inline shape の patch に展開する。
// 戻り値は viewConfigKpiSchema.safeParse に渡される loose な部分形 (measure / user は Partial 許容)。
type ViewConfigKpiPatch = Partial<Pick<ViewConfigKpi, 'sheet' | 'date'>> & {
  measure?: KpiFormMetricFormValue['measure']
  user?: KpiFormMetricFormValue['user']
}

export const metricFormValueToViewConfigKpiPatch = (m: KpiFormMetricFormValue | undefined): ViewConfigKpiPatch => {
  if (m === undefined) return {}
  return {
    sheet: m.sheet,
    measure: m.measure,
    date: m.date,
    user: m.user,
  }
}

// KpiForm の metricFormValue を浅いマージで更新する純関数ヘルパー。
// `setForm((oldValue) => updateMetricFormValue(oldValue, { ... }))` の形で使う。
export const updateMetricFormValue = (form: KpiForm, patch: Partial<KpiFormMetricFormValue>): KpiForm => ({
  ...form,
  metricFormValue: { ...form.metricFormValue, ...patch },
})
